
import DefaultLandingPage from "../features/components/landing-page-group.tsx";
// import Crani from "../components/layouts/HomePage";
import EntVideoPage from "../components/layouts/EntVideoPage.tsx";
import EntDemoPage from "../components/layouts/EntDemoPage.tsx";
import ContactThemeGenerate from "../features/components/color_theme.tsx";
import SpineStaticLegal from "../features/utahlegal/utahlegal.tsx";
import Login from "../userAuth/Login/index.tsx";
// import OtpVerify from "../userAuth/otp/OtpVerify";
import ShareAnimation from "../users/shareAnimation/index.tsx";
import UserProfile from "../users/settings/profileSetings/userProfile.tsx";
import Rejoni from "../features/rejoni/index.tsx";
import RejoniPresentation from "../features/rejoni-presentation/rejoni.tsx";
import DefaultMessageSetting from "../users/settings/shareanimationSetings/defaultMessageSetting.tsx";
import ManagerUser from "../users/manageAccounts/manageUsers.tsx";
import Logout from "../userAuth/Login/logout.tsx";
import LoopSetting from "../users/animationloop/loopsetting.tsx";
import HomePage from "../users/dashboard/home/homePage.tsx";
// import Subscription from "../userAuth/Subscription/subcriptionPage.tsx";
import EmailTemplate from "../users/emailTemplate/email_template.tsx";
import ShortURLAnimationViewnew from "../features/animationView/animationViewnew.tsx";
import LigerFinal from "../features/liger/ligerFinalDelivery.tsx";
import ManageLocation from "../users/manageAccounts/manageLocations/manageLocation.tsx";
import UsageReport from "../users/reports/usageReports.tsx";
import ManageLocationsClass from "../users/manageAccounts/manageLocationclass/managelocationsclass.tsx";
import ManageFavourites from "../users/manageAccounts/manageFavourites/manageFavourites.tsx";
import SharedAnimationReport from "../users/reports/sharedAnimationReport.tsx";
import Favorites from "../users/favorites/favorites.tsx";
import PreloginAboutUs from "../PreloginComponent/Layout/AboutUs.tsx";
import PreloginContact from "../PreloginComponent/Layout/ContactUs.tsx";
import Signup from "../PreloginComponent/Layout/Signup.tsx";
import PreloginServices from "../PreloginComponent/Layout/Services.tsx";
import Success from "../users/stripe/stripeSuccess.tsx";
import Failure from "../users/stripe/failureStripe.tsx";
import WomensHealthDemo from "../components/layouts/womensHealthDemo.tsx";
import BusinessCards from "../PreloginComponent/OurVisionaries/BusinessCards.tsx";
import ManageCategories from "../users/settings/manageCategory/manageCategories.tsx";
import ManageSubscription from "../users/manageAccounts/manageSubscriptions/manageSubscription.tsx";
import AnimationDemoPage from "../components/layouts/Animationdemos.tsx";
import CustomAnimations from "../components/layouts/customAnimatons.tsx";
import MyVideos from "../users/myVideos/myVideos.tsx";

import PreloginHome2 from "../PreloginComponent/Layout/PreloginHome/PreloginHome.tsx";
import CustomDemos from "../components/layouts/customDemos.tsx";
import { useSearchParams } from "react-router-dom";
import ResetPassword from "../userAuth/Resetpassword/resetPassword.tsx";
import Custom404 from "../features/components/custom-404.tsx";
import Crani from "../components/layouts/HomePage.tsx";
import Sealonix from "../features/spine/spine-static.tsx";
import GutLab from "../features/gutlab/gutlab.tsx";
import Liger from "../features/liger/liger.tsx";

const ProtectedResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return token ? <ResetPassword /> : <Custom404 />;
};

export const publicRoutes = [
    { path: "/", component: PreloginHome2 },
    { path: "/old-landing", component: DefaultLandingPage },
    { path: "/shareDesign", component: ShortURLAnimationViewnew },
    { path: "/custom-animations", component: CustomAnimations },
    { path: "/ent", component: EntVideoPage },
    { path: "/demo", component: AnimationDemoPage },
    { path: "/demos", component: CustomDemos },
    { path: "/entdemo", component: EntDemoPage },
    { path: "/whdemo", component: WomensHealthDemo },
    { path: "/utahlegalvideo", component: SpineStaticLegal },
    { path: "/rejoni", component: Rejoni },
    { path: "/rejoni-presentation", component: RejoniPresentation },
    { path: "/contact-us-theme", component: ContactThemeGenerate },
    { path: "/signup", component: Signup },
    { path: "/login", component: Login },
    { path: "/emailtemplate", component: EmailTemplate },
    { path: "/finalDelivery/liger", component: LigerFinal },
    { path: "/contactus", component: PreloginContact },
    { path: "/aboutus", component: PreloginAboutUs },
    { path: "/services", component: PreloginServices },
    { path: "/freetrial", component: Signup },
    { path: "/payment-success", component: Success },
    { path: "/payment-cancel", component: Failure },
    { path: "/business-cards/:user", component: BusinessCards },
    { path: "/resetpassword", component: ProtectedResetPassword },
    { path: "/crani", component: Crani },
    { path: "/ent", component: EntVideoPage },
    { path: "/sealonix", component: Sealonix },
    { path: "/gutlab", component: GutLab },
    { path: "/liger", component: Liger },
];

export const privateRoutes = [
    { name: "Home", path: "/home", component: HomePage },
    { name: "Share Animation", path: "/share-animation", component: ShareAnimation },
    { name: "Favorites", path: "/favorites", component: Favorites },
    { name: "My Videos", path: "/my-videos", component: MyVideos },
    { name: "Profile Setting", path: "/profile-setting", component: UserProfile },
    { name: "Email Setting", path: "/email-setting", component: DefaultMessageSetting },
    { name: "Manage Favorites", path: "/manage-favorites", component: ManageFavourites },
    { name: "Manage Categories", path: "/manage-categories", component: ManageCategories },
    { name: "Manage Locations", path: "/settings/manage-locations", component: ManageLocation },
    { name: "Manage Locations Class", path: "/settings/manage-locations-class", component: ManageLocationsClass },
    { name: "Manage Users", path: "/settings/manage-users", component: ManagerUser },
    { name: "Manage Subscriptions", path: "/settings/manage-subscriptions", component: ManageSubscription },
    { name: "Loop Setting", path: "/animationloop/loop-setting", component: LoopSetting },
    { name: "Usage Reports", path: "/usageReports", component: UsageReport },
    { name: "Shared Animation Report", path: "/shared-animation-report", component: SharedAnimationReport },
    { name: "logout", path: "/logout", component: Logout }
];